<template>
<div>
    <MenuPos />
    <div class="d-flex justify-space-between mb-2">
        <h2>สั่งอาหารด่วน</h2>
        <v-btn class="d-none grad-primary-bg d-sm-flex white--text" height="50" width="20%" @click="$router.push('/poslist')">
            ย้อนกลับ
        </v-btn>
        <v-btn class="d-flex grad-primary-bg d-sm-none white--text" height="50" @click="$router.push('/poslist')">
            ย้อนกลับ
        </v-btn>
    </div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_send_food === true">สั่งอาหารเข้าครัวเรียบร้อย</v-alert>
        <v-alert type="warning" class="alert_success" v-if="alert_waiting === true">กำลังทำการพิมพ์ออเดอร์กรุณารอสักครู่...</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-row>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                <BillQuickFoodOrder :token="token" :re_bill="reset_bill" :takehome_id="takehome_id" :list_food="list_food" @remove_food="removeFood"/>
            </v-col>
            <v-col cols="12" sm="8" md="8" lg="8" xl="8">
                <v-card>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="8" md="8" lg="8" xl="8">
                                <div class="d-none d-sm-flex align-center all_card_select_quick_pos_table_detail">
                                    <div>
                                        <v-btn :color="type_food == 'a la carte' ? '#038cc1':''" :class="type_food == 'a la carte' ? 'white--text':''" height="100" @click="type_food = 'a la carte'">
                                            A La Carte
                                        </v-btn>
                                    </div>
                                    <div>
                                        <v-btn :color="type_food == 'drink' ? '#038cc1':''" :class="type_food == 'drink' ? 'white--text':''" height="100" @click="type_food = 'drink'">
                                            เครื่องดื่ม
                                        </v-btn>
                                    </div>
                                </div>

                                <div class="d-block d-sm-none align-center">

                                    <v-btn :color="type_food == 'a la carte' ? '#038cc1':''" :class="type_food == 'a la carte' ? 'white--text mb-3':'mb-3'" height="50" width="100%" @click="type_food = 'a la carte'">
                                        A La Carte
                                    </v-btn>

                                    <v-btn :color="type_food == 'drink' ? '#038cc1':''" :class="type_food == 'drink' ? 'white--text mb-3':'mb-3'" height="50" width="100%" @click="type_food = 'drink'">
                                        เครื่องดื่ม
                                    </v-btn>
                                </div>

                            </v-col>
                            <!-- <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                                <div class="d-flex justify-center align-center list_food_pos_table_detail" @click="openCheckFood()">
                                    <v-card :class="list_food.length > 0 ? 'text-center number_list_pos_table_detail titlefont_pos_table_detail white--text' : 'text-center number_list_pos_table_detail titlefont_pos_table_detail'" :color="list_food.length > 0 ? 'error' : ''">
                                        <div>{{ list_food.length > 0 ? 'กรุณายืนยันรายการ' : 'รายการ'}}</div>
                                        <div>{{ list_food.length }}</div>
                                    </v-card>
                                </div>

                            </v-col> -->
                        </v-row>
                        <PosTableDetailALaCarte @eventGetDetail="getDetailFood" :type_table="type_table" v-show="type_food == 'a la carte'" />
                        <PosTableDetailDrink @eventGetDetail="getDetailFood" v-show="type_food == 'drink'" />
                    </v-container>

                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="open_add_food" persistent max-width="600px">
            <div v-if="loading_page_add_food === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_add_food === false">
                <v-form ref="form" @submit.prevent="addFood()">
                    <v-card-title class="justify-end">
                        <div class="cursor_icon_pos_table_detail" @click="closeAddFood()">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <div class="add_menu_image_pos_table_detail">
                            <img :src="food_detail.path">
                        </div>
                        <v-container>
                            <v-row>
                                <v-col cols="8">
                                    <div>
                                        {{ food_detail.name }}
                                    </div>
                                </v-col>
                                <v-col cols="4">
                                    <div class="text-right">
                                        {{ food_detail.price }} ฿
                                    </div>
                                </v-col>
                                <v-col cols="12">
                                    <div class="description_detail_pos_table_detail">
                                        {{ food_detail.description }}
                                    </div>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <div v-for="(detail,key) in food_detail.categoriesToping" :key="key">
                                        <div v-if="detail.choose == 0 && detail.status_limit == 0" class="mt-0">
                                            <div class="mt-2">
                                                <div>{{ detail.name }} <span>( สามารถเลือกท๊อปปิ้งได้ )</span></div>
                                                <div class="d-flex justify-space-between mt-2" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                    <div class="d-flex" v-if="detail_list.status == 1">
                                                        <v-checkbox v-model="choice_topping[key].toppingList" color="primary" :value="detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'" class="check_food_pos_table_detail" @change="checkSendFood()"></v-checkbox>
                                                        <div>{{ detail_list.name }}</div>
                                                    </div>
                                                    <div class="d-flex" v-if="detail_list.status == 0">
                                                        <v-checkbox v-model="choice_topping[key].toppingList" color="primary" class="check_food_pos_table_detail" disabled></v-checkbox>
                                                        <div>{{ detail_list.name }} <span class="out_of_stock_pos_table_detail">(ของหมด)</span></div>
                                                    </div>
                                                    <div>
                                                        +{{ detail_list.price }} ฿
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="detail.choose == 0 && detail.status_limit == 1" class="mt-0">
                                            <div class="mt-2">
                                                <div>{{ detail.name }} <span>( สามารถเลือกท๊อปปิ้งได้ไม่เกิน {{ detail.limit }} อย่าง )</span></div>
                                                <div class="d-flex justify-space-between mt-2" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                    <div class="d-flex" v-if="detail_list.status == 1">
                                                        <v-checkbox v-model="choice_topping[key].toppingList" :disabled="choice_topping[key].toppingList.length >= detail.limit && choice_topping[key].toppingList.indexOf(detail_list.id+','+detail_list.price+','+detail_list.name+','+'1') === -1" color="primary" :value="detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'" class="check_food_pos_table_detail" @change="checkSendFood()"></v-checkbox>
                                                        <div>{{ detail_list.name }}</div>
                                                    </div>
                                                    <div class="d-flex" v-if="detail_list.status == 0">
                                                        <v-checkbox v-model="choice_topping[key].toppingList" color="primary" class="check_food_pos_table_detail" disabled></v-checkbox>
                                                        <div>{{ detail_list.name }} <span class="out_of_stock_pos_table_detail">(ของหมด)</span></div>
                                                    </div>
                                                    <div>
                                                        +{{ detail_list.price }} ฿
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="detail.choose == 0 && detail.status_limit == 2" class="mt-0">
                                            <div class="mt-2">
                                                <div>{{ detail.name }} <span>( กรุณาใส่จำนวน )</span></div>
                                                <div class="d-flex justify-space-between mt-2" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                    <div class="d-flex" v-if="detail_list.status == 1">
                                                        <div class="d-flex align-center mr-2">
                                                            <div @click="addNumTopping('minus',key,key_detail)" class="cursor_icon_pos_table_detail">
                                                                <v-icon size="25">mdi-minus-circle</v-icon>
                                                            </div>
                                                            <div class="ml-1 mr-1 cursor_icon_pos_table_detail font_amount_topping_pos_table_detail" :key="detail_list.amount">
                                                                {{ detail_list.amount }}
                                                            </div>

                                                            <div @click="addNumTopping('plus',key,key_detail)" class="cursor_icon_pos_table_detail">
                                                                <v-icon size="25">mdi-plus-circle</v-icon>
                                                            </div>
                                                        </div>
                                                        <div>{{ detail_list.name }}</div>
                                                    </div>
                                                    <div class="d-flex" v-if="detail_list.status == 0">
                                                        <div class="d-flex align-center mr-2">
                                                            <div class="cursor_icon_pos_table_detail">
                                                                <v-icon size="25">mdi-minus-circle</v-icon>
                                                            </div>
                                                            <div class="ml-1 mr-1 cursor_icon_pos_table_detail font_amount_topping_pos_table_detail" :key="detail_list.amount">
                                                                {{ detail_list.amount }}
                                                            </div>

                                                            <div class="cursor_icon_pos_table_detail">
                                                                <v-icon size="25">mdi-plus-circle</v-icon>
                                                            </div>
                                                        </div>
                                                        <div>{{ detail_list.name }} <span class="out_of_stock_pos_table_detail">(ของหมด)</span></div>
                                                    </div>
                                                    <div>
                                                        +{{ detail_list.price }} ฿
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="detail.choose == 1 && detail.status_limit == 0" class="mt-0">
                                            <div class="mt-2">
                                                <div>{{ detail.name }} <span>( กรุณาเลือกท๊อปปิ้ง )</span></div>
                                                <div class="d-flex justify-space-between mt-2" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                    <div class="d-flex" v-if="detail_list.status == 1">
                                                        <v-checkbox v-model="choice_topping[key].toppingList" color="primary" :value="detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'" class="check_food_pos_table_detail" @change="checkSendFood()"></v-checkbox>
                                                        <div>{{ detail_list.name }}</div>
                                                    </div>
                                                    <div class="d-flex" v-if="detail_list.status == 0">
                                                        <v-checkbox v-model="choice_topping[key].toppingList" color="primary" class="check_food_pos_table_detail" disabled></v-checkbox>
                                                        <div>{{ detail_list.name }} <span class="out_of_stock_pos_table_detail">(ของหมด)</span></div>
                                                    </div>
                                                    <div>
                                                        +{{ detail_list.price }} ฿
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="detail.choose == 1 && detail.status_limit == 1" class="mt-0">
                                            <div class="mt-2">
                                                <div>
                                                    {{ detail.name }}
                                                    <span>( กรุณาเลือกท๊อปปิ้ง สามารถเลือกได้ไม่เกิน {{ detail.limit }} อย่าง )</span>
                                                </div>
                                                <div class="d-flex justify-space-between mt-2" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                    <div class="d-flex" v-if="detail_list.status == 1">
                                                        <v-checkbox v-model="choice_topping[key].toppingList" :disabled="choice_topping[key].toppingList.length >= detail.limit && choice_topping[key].toppingList.indexOf(detail_list.id+','+detail_list.price+','+detail_list.name+','+'1') === -1" color="primary" :value="detail_list.id+','+detail_list.price+','+detail_list.name+','+'1'" class="check_food_pos_table_detail" @change="checkSendFood()"></v-checkbox>
                                                        <div>{{ detail_list.name }}</div>
                                                    </div>
                                                    <div class="d-flex" v-if="detail_list.status == 0">
                                                        <v-checkbox v-model="choice_topping[key].toppingList" color="primary" class="check_food_pos_table_detail" disabled></v-checkbox>
                                                        <div>{{ detail_list.name }} <span class="out_of_stock_pos_table_detail">(ของหมด)</span></div>
                                                    </div>
                                                    <div>
                                                        +{{ detail_list.price }} ฿
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="detail.choose == 1 && detail.status_limit == 2" class="mt-0">
                                            <div class="mt-2">
                                                <div>
                                                    {{ detail.name }} <span>( กรุณาใส่จำนวน )</span>
                                                </div>
                                                <div class="d-flex justify-space-between mt-2" v-for="(detail_list,key_detail) in detail.listToping" :key="key_detail">
                                                    <div class="d-flex" v-if="detail_list.status == 1">
                                                        <div class="d-flex align-center mr-2">
                                                            <div @click="addNumTopping('minus',key,key_detail)" class="cursor_icon_pos_table_detail">
                                                                <v-icon size="25">mdi-minus-circle</v-icon>
                                                            </div>
                                                            <div class="ml-1 mr-1 cursor_icon_pos_table_detail font_amount_topping_pos_table_detail" :key="detail_list.amount">
                                                                {{ detail_list.amount }}
                                                            </div>

                                                            <div @click="addNumTopping('plus',key,key_detail)" class="cursor_icon_pos_table_detail">
                                                                <v-icon size="25">mdi-plus-circle</v-icon>
                                                            </div>
                                                        </div>
                                                        <div>{{ detail_list.name }}</div>
                                                    </div>
                                                    <div class="d-flex" v-if="detail_list.status == 0">
                                                        <div class="d-flex align-center mr-2">
                                                            <div class="cursor_icon_pos_table_detail">
                                                                <v-icon size="25">mdi-minus-circle</v-icon>
                                                            </div>
                                                            <div class="ml-1 mr-1 cursor_icon_pos_table_detail font_amount_topping_pos_table_detail" :key="detail_list.amount">
                                                                {{ detail_list.amount }}
                                                            </div>

                                                            <div class="cursor_icon_pos_table_detail">
                                                                <v-icon size="25">mdi-plus-circle</v-icon>
                                                            </div>
                                                        </div>
                                                        <div>{{ detail_list.name }} <span class="out_of_stock_pos_table_detail">(ของหมด)</span></div>
                                                    </div>
                                                    <div>
                                                        +{{ detail_list.price }} ฿
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <v-expansion-panels class="add_note_pos_table_detail">
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>
                                                เพิ่มหมายเหตุ
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-textarea outlined label="เพิ่มหมายเหตุ" v-model="description"></v-textarea>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <div class="d-flex justify-center align-center">
                                        <div class="d-flex align-center">
                                            <div @click="addNumFood('minus')" class="cursor_icon_pos_table_detail">
                                                <v-icon size="40">mdi-minus-circle</v-icon>
                                            </div>
                                            <div class="ml-2 mr-2 cursor_icon_pos_table_detail" :key="add_num_food">
                                                {{ add_num_food }}
                                            </div>

                                            <div @click="addNumFood('plus')" class="cursor_icon_pos_table_detail">
                                                <v-icon size="40">mdi-plus-circle</v-icon>
                                            </div>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12">
                                    <div class="topping_out_pos_table_detail" v-if="button_send_food">
                                        กรุณาเลือกท๊อปปิ้ง*
                                    </div>
                                    <div class="d-flex justify-center align-center">
                                        <v-btn color="#28ab28" class="white--text" height="50" width="100%" type="submit" :disabled="button_send_food">
                                            เพิ่มลงในตะกร้า
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>

                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="open_check_food" persistent max-width="600px">
            <div v-if="loading_page_check_food === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_check_food === false">

                <v-card-title class="d-flex justify-space-between header_check_food_pos_table_detail" v-if="list_food.length > 0">
                    <div class="title_check_food_pos_table_detail color_yellow_pos_table_detail send_food_pos_table_detail" @click="sendFood(0)" v-if="list_food.length > 0">
                        ยืนยัน ทานที่ร้าน
                    </div>
                    <div class="title_check_food_pos_table_detail color_green_pos_table_detail send_food_pos_table_detail" @click="sendFood(1)" v-if="list_food.length > 0">
                        ยืนยัน ซื้อกลับบ้าน
                    </div>

                </v-card-title>

                <v-card-title class="d-flex justify-space-between header_check_food_not_pos_table_detail" v-if="list_food.length == 0">

                </v-card-title>

                <v-card-text>

                    <v-row>
                        <v-col cols="12">
                            <div class="d-flex mt-2 mb-2">
                                <div class="d-flex align-center ml-4 mr-4">
                                    <div class="mr-1 food_table_takehome_pos_table_detail"></div>
                                    <div>ซื้อกลับบ้าน</div>
                                </div>
                                <div class="d-flex align-center">
                                    <div class="mr-1 food_cart_pos_table_detail"></div>
                                    <div>กำลังหยิบใส่ตระกร้า</div>
                                </div>
                            </div>
                            <v-expansion-panels v-model="panel">
                                <v-expansion-panel class="mt-2 header_panel_pos_table_detail">
                                    <v-expansion-panel-header class="color_font_pos_table_detail">
                                        <div>Order # {{ number_order }} เวลา {{ new Date().getHours() }}.{{ new Date().getMinutes() }} น.</div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="body_food_pos_table_detail">
                                        <v-card color="orange lighten-5" class="pa-3 d-flex align-center justify-space-between mt-2" v-for="(food,new_key) in list_food" :key="new_key">
                                            <div class="d-flex align-center">
                                                <div class="mr-2 pa-3 amount_food_pos_table_detail">{{ food.amount }}</div>
                                                <div>{{ food.name }}
                                                    <div class="topping_food_pos_table_detail">
                                                        <ul>
                                                            <li v-for="(topping_name_list,key_topping) in food.topping_name" :key="key_topping">
                                                                <span v-if="food.amount_topping[key_topping]" class="amount_list_topping_pos_table_detail">{{ food.amount_topping[key_topping] }}</span> {{ topping_name_list }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="note_pos_table_detail" v-if="food.description">
                                                        หมายเหตุ : {{ food.description }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <v-icon color="error" @click="deleteCart(food.id)">mdi-close</v-icon>
                                            </div>

                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                                <v-expansion-panel class="mt-2 header_panel_pos_table_detail" v-for="(order_history_detail,key_history) in order_history" :key="key_history">
                                    <v-expansion-panel-header class="color_font_history_pos_table_detail" v-if="order_history_detail.status_takehome == 0">
                                        <div class="d-flex align-center">
                                            <div class="print_order_list mr-2" @click="printOrderDetail(order_history_detail)">
                                                <v-icon>mdi-printer</v-icon>
                                            </div>
                                            <div>Order # {{ order_history_detail.order }} เวลา {{ order_history_detail.time }} น.</div>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-header class="color_font_history_takehome_pos_table_detail" v-if="order_history_detail.status_takehome == 1">
                                        <div class="d-flex align-center">
                                            <div class="print_order_list mr-2" @click="printOrderDetail(order_history_detail)">
                                                <v-icon>mdi-printer</v-icon>
                                            </div>
                                            <div>Order # {{ order_history_detail.order }} เวลา {{ order_history_detail.time }} น.</div>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="body_food_pos_table_detail">
                                        <v-card color="orange lighten-5" class="pa-3 d-flex align-center mt-2" v-for="(history_detail,list_history_key) in order_history_detail.listDetaile" :key="list_history_key">
                                            <div class="d-flex align-center">
                                                <div class="mr-2 pa-3 amount_food_pos_table_detail">{{ history_detail.amount }}</div>
                                                <div>{{ history_detail.food }}
                                                    <div class="topping_food_pos_table_detail">
                                                        <ul>
                                                            <li v-for="(topping_name_list,key_topping) in history_detail.listTop" :key="key_topping">
                                                                <span v-if="topping_name_list.amount" class="amount_list_topping_pos_table_detail">{{ topping_name_list.amount }}</span> {{ topping_name_list.topingName }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="note_pos_table_detail" v-if="history_detail.description">
                                                        หมายเหตุ : {{ history_detail.description }}
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" type="button" @click="open_check_food = false">
                        ปิด
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>

        <v-dialog v-model="open_detail_order_print" persistent max-width="600">
            <div v-if="loading_page_detail_order_print === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_detail_order_print === false">
                <v-card-title>
                    ยืนยันการพิมพ์ออเดอร์
                </v-card-title>

                <v-card-text>
                    <div v-if="order_detail_print">
                        Order # {{ order_detail_print.order }} {{ order_detail_print.table }} เวลา {{ order_detail_print.time }} น.
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="printOrder()">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="closePrintOrder()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import MenuPos from '@/components/menuadmin/MenuPos.vue'
import BillQuickFoodOrder from '@/components/menuadmin/BillQuickFoodOrder.vue'
import PosTableDetailALaCarte from '@/components/menuadmin/PosTableDetailALaCarte.vue'
import PosTableDetailDrink from '@/components/menuadmin/PosTableDetailDrink.vue'

export default {
    name: 'quickFoodOrder',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    components: {
        MenuPos,
        BillQuickFoodOrder,
        PosTableDetailALaCarte,
        PosTableDetailDrink,
    },
    data() {
        return {
            loading_page: false,
            alert_show_send_food: false,
            alert_waiting: false,
            invoice_id: null,
            token: null,
            type_table: 'ไม่บุฟเฟ่',
            type_food: 'a la carte',
            list_food: [],
            list_food_id: 1,
            loading_page_add_food: true,
            open_add_food: false,
            food_detail: null,
            description: '',
            add_num_food: 1,
            choice_topping: [],
            button_send_food: false,
            open_check_food: false,
            loading_page_check_food: false,
            panel: 0,
            number_order: "",
            order_history: [],
            open_detail_order_print: false,
            loading_page_detail_order_print: false,
            order_detail_print: null,
            order_print_id: null,
            reset_bill: false,
        }
    },
    methods: {
        // async quickFoodOrderDetail() {
        //     this.loading_page = true
        //     HTTP.get('/fastOrderDetail/' + this.$store.state.tokenQuickFoodOrder, {
        //             headers: {
        //                 "Authorization": `Bearer ${this.$store.state.token}`
        //             }
        //         })
        //         .then((response) => {
        //             if (response.data.successful === true) {
        //                 this.takehome_id = response.data.invoiceDetaile.takehome_id
        //                 this.token = this.$store.state.tokenQuickFoodOrder
        //                 this.invoice_id = this.$store.state.invoiceQuickFoodOrderId
        //                 this.loading_page = false
        //             }

        //             if (response.data.successful === false) {
        //                 this.alert_error = true
        //             }

        //         }).catch((error) => {
        //             if (error.response.status === 401) {
        //                 this.$store.commit('logOutSuccess')
        //                 this.$router.push('/login')
        //             }
        //         })

        // },
        async getDetailFood(data) {
            this.loading_page_add_food = true
            this.open_add_food = true
            this.food_detail = null
            this.description = ''
            this.add_num_food = 1
            this.choice_topping = []
            this.button_send_food = false
            if (data.type !== null) {
                HTTP.get('/POS/table/detail-food-menu/' + data.id + '?type=' + data.type, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.food_detail = response.data.fooddetail
                            for (let index = 0; index < response.data.fooddetail.categoriesToping.length; index++) {
                                this.choice_topping.push({
                                    choose: response.data.fooddetail.categoriesToping[index].choose,
                                    status_limit: response.data.fooddetail.categoriesToping[index].status_limit,
                                    limit: response.data.fooddetail.categoriesToping[index].limit,
                                    toppingList: []
                                })

                                if (response.data.fooddetail.categoriesToping[index].choose == 1) {
                                    this.button_send_food = true
                                }
                            }
                            this.loading_page_add_food = false
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }

            if (data.type === null) {
                HTTP.get('/POS/table/detail-food-menu/' + data.id, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.food_detail = response.data.fooddetail
                            for (let index = 0; index < response.data.fooddetail.categoriesToping.length; index++) {
                                this.choice_topping.push({
                                    choose: response.data.fooddetail.categoriesToping[index].choose,
                                    status_limit: response.data.fooddetail.categoriesToping[index].status_limit,
                                    limit: response.data.fooddetail.categoriesToping[index].limit,
                                    toppingList: []
                                })

                                if (response.data.fooddetail.categoriesToping[index].choose == 1) {
                                    this.button_send_food = true
                                }
                            }

                            this.loading_page_add_food = false
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }

        },

        async checkSendFood() {
            this.button_send_food = true
            let checkAll = []
            const chooseNumberAll = this.food_detail.categoriesToping.filter((detail) => {
                return detail.choose == 1 && detail.status_limit == 2
            })
            chooseNumberAll.forEach((listTopingList) => {
                let arr_topping = []
                for (let index = 0; index < listTopingList.listToping.length; index++) {
                    if (listTopingList.listToping[index].amount == 0) {
                        arr_topping.push(true)
                    }else{
                        arr_topping.push(false)
                    }
                }
                let checkTopping = arr_topping.some((detail) => {
                    return detail === false
                })
                if (checkTopping === true) {
                    checkTopping = false
                }else{
                    checkTopping = true
                }
                checkAll.push(checkTopping)
            })

            const chooseAll = this.choice_topping.filter((detail) => {
                return detail.choose == 1 && detail.status_limit != 2
            })
            chooseAll.forEach((detail) => {
                if (detail.status_limit == 0 && detail.toppingList.length <= 0 || detail.status_limit == 1 && detail.toppingList.length <= 0) {
                    checkAll.push(true)
                }else{
                    checkAll.push(false)
                }
            })

            this.button_send_food = checkAll.some((detail) => {
                return detail === true
            })
        },

        async addNumTopping(type, key_title, key_detail) {
            this.button_send_food = true
            let topingList = this.food_detail.categoriesToping[key_title].listToping[key_detail]
            if (type === 'plus') {
                topingList.amount += 1
            }
            if (type === 'minus' && topingList.amount > 0) {
                topingList.amount -= 1
            }

            let checkAll = []
            const chooseNumberAll = this.food_detail.categoriesToping.filter((detail) => {
                return detail.choose == 1 && detail.status_limit == 2
            })
            chooseNumberAll.forEach((listTopingList) => {
                let arr_topping = []
                for (let index = 0; index < listTopingList.listToping.length; index++) {
                    if (listTopingList.listToping[index].amount == 0) {
                        arr_topping.push(true)
                    }else{
                        arr_topping.push(false)
                    }
                }
                let checkTopping = arr_topping.some((detail) => {
                    return detail === false
                })
                if (checkTopping === true) {
                    checkTopping = false
                }else{
                    checkTopping = true
                }
                checkAll.push(checkTopping)
            })

            const chooseAll = this.choice_topping.filter((detail) => {
                return detail.choose == 1 && detail.status_limit != 2
            })
            chooseAll.forEach((detail) => {
                if (detail.status_limit == 0 && detail.toppingList.length <= 0 || detail.status_limit == 1 && detail.toppingList.length <= 0) {
                    checkAll.push(true)
                }else{
                    checkAll.push(false)
                }
            })

            this.button_send_food = checkAll.some((detail) => {
                return detail === true
            })
        },
        async addNumFood(type) {
            if (type === 'plus') {
                this.add_num_food += 1
            }
            if (type === 'minus' && this.add_num_food > 1) {
                this.add_num_food -= 1
            }
        },

        async addFood() {
            if (this.$refs.form.validate()) {
                if (this.add_num_food > 0) {
                    this.open_add_food = false
                    let total = this.food_detail.price * this.add_num_food
                    let choice_topping_id = []
                    let choice_topping_name = []
                    let toppingprice = 0
                    let toppingprice_list = []
                    let topping_arr_list = []
                    let amount_topping = []
                    this.choice_topping.forEach(toppingDetail => {
                        toppingDetail.toppingList.forEach(detail => {
                            let res = detail.split(',')
                            let res_id = res[0]
                            let res_price = res[1]
                            let res_name = res[2]
                            let res_amount = res[3]
                            choice_topping_id.push(res_id)
                            choice_topping_name.push(res_name)
                            // total += parseInt(res_price)
                            toppingprice += res_price * res_amount
                            toppingprice_list.push(res_price)
                            amount_topping.push(parseInt(res_amount))
                            topping_arr_list.push({
                                id: parseInt(res_id),
                                price: res_price,
                                amount: parseInt(res_amount),
                                description: this.description.replace(this.$store.state.checkEmoji, ""),
                            })
                        })
                    })
                    this.food_detail.categoriesToping.forEach(detail => {
                        if (detail.status_limit == 2) {
                            detail.listToping.forEach(detail_list => {
                                if (detail_list.amount > 0) {
                                    choice_topping_id.push(detail_list.id)
                                    choice_topping_name.push(detail_list.name)
                                    toppingprice += detail_list.price * detail_list.amount
                                    toppingprice_list.push(detail_list.price)
                                    amount_topping.push(parseInt(detail_list.amount))
                                    topping_arr_list.push({
                                        id: parseInt(detail_list.id),
                                        price: detail_list.price,
                                        amount: parseInt(detail_list.amount),
                                        description: this.description.replace(this.$store.state.checkEmoji, ""),
                                    })
                                }
                            })
                        }
                    })
                    let send_total_price = (this.add_num_food * toppingprice) + total
                    this.list_food.push({
                        id: this.list_food_id,
                        foodmenu_id: this.food_detail.id,
                        name: this.food_detail.name,
                        amount: this.add_num_food,
                        price: this.food_detail.price,
                        total_price: send_total_price,
                        toping_id: choice_topping_id.toString(),
                        topping_name: choice_topping_name,
                        amount_topping: amount_topping,
                        toppingprice: toppingprice,
                        toppingprice_list: toppingprice_list,
                        topping_arr_list: topping_arr_list,
                        description: this.description.replace(this.$store.state.checkEmoji, ""),
                    })

                    this.list_food_id += 1
                    this.description = ''
                    this.add_num_food = 1

                    this.reset_bill = true
                    setTimeout(() => this.reset_bill = false, 500)
                }
            }
        },
        async closeAddFood() {
            this.open_add_food = false
            this.add_num_food = 1
        },
        async openCheckFood() {
            this.loading_page_check_food = true
            this.open_check_food = true
            this.order_history = []
            await HTTP.get('/POS/table/order-number', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.number_order = response.data.order_number
                        this.loading_page_check_food = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

            HTTP.get('/POS/order-takehome-list/' +   this.takehome_id, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.order_history = response.data.orderList

                        this.loading_page_check_food = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

        },
        async deleteCart(id) {
            this.list_food = this.list_food.filter(detail => detail.id !== id)
        },
        async sendFood(type) {
            if (this.list_food.length > 0) {
                this.loading_page_check_food = true
                let foodmenu_id = []
                let amount = []
                let price = []
                let total_price = []
                let toping_id = []
                let topping_price = []
                let description = []

                this.list_food.forEach(detail => {
                    foodmenu_id.push(detail.foodmenu_id)
                    amount.push(detail.amount)
                    price.push(detail.price)
                    total_price.push(detail.total_price)
                    topping_price.push(detail.toppingprice)
                    toping_id.push(detail.topping_arr_list)
                    description.push(detail.description)
                });

                // HTTP.post('/fastOrdercreate/' + this.token, {
                HTTP.post('/fastOrdercreate', {
                        foodmenu_id: foodmenu_id,
                        amount: amount,
                        price: price,
                        total_price: total_price,
                        topping_price: topping_price,
                        toping_id: toping_id,
                        description: description,
                        type: type,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.list_food = []
                            this.loading_page_check_food = false
                            this.open_check_food = false
                            this.alert_show_send_food = true
                            setTimeout(() => this.alert_show_send_food = false, 5000)

                            this.reset_bill = true

                            setTimeout(() => this.reset_bill = false, 500)

                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },

        async printOrderDetail(detail) {
            this.open_detail_order_print = true
            this.loading_page_detail_order_print = true
            this.order_detail_print = detail
            this.order_print_id = detail.id
            this.loading_page_detail_order_print = false
        },
        async closePrintOrder() {
            this.loading_page_detail_order_print = true
            this.order_detail_print = null
            this.order_print_id = null
            this.open_detail_order_print = false
        },
        async printOrder() {
            this.loading_page_detail_order_print = true
            this.open_detail_order_print = false

            HTTP.post('/ordertakehome-status-update-print-again/' + this.order_print_id, null, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.alert_waiting = true
                        setTimeout(() => this.alert_waiting = false, 5000)
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

        },
        async removeFood(data){
            this.list_food = data
            this.reset_bill = true
            setTimeout(() => this.reset_bill = false, 500)
        }
    },
    mounted() {
        // this.quickFoodOrderDetail()
    }
}
</script>
